define("shared/components/shared/stop-the-world-modal", ["exports", "@ember/component", "@ember/template-factory", "@ember/service", "@glimmer/component"], function (_exports, _component, _templateFactory, _service, _component2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2;

  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.currentAccount.stopTheWorld}}
    <Shared::Modal @closable={{false}} as |modal|>
  
      <modal.card @portrait={{true}}>
  
        <modal.card-header @title={{t "account.stop_the_world.title" planName=this.planName}} />
  
        <modal.card-body>
          {{#if this.currentAccount.shouldWarnOfPlanOverages}}
            <p>{{t "account.stop_the_world.overages.message"}}</p>
            <ul>
              {{#if this.hasLinkinbioPagesOverage}}
                <li>{{t "account.stop_the_world.overages.linkinbio_pages" count=this.linkinbioPagesOverage}}</li>
              {{/if}}
              {{#if this.currentAccount.hasGroupsOverage}}
                <li>{{t "account.stop_the_world.overages.groups" count=this.currentAccount.groupsOverage}}</li>
              {{/if}}
  
              {{#if this.currentAccount.hasUsersOverage}}
                <li>{{t "account.stop_the_world.overages.users" count=this.currentAccount.usersOverage}}</li>
              {{/if}}
  
              {{#if this.currentAccount.hasSocialProfileOverage}}
                <li>
                  {{t "account.stop_the_world.overages.social_profiles" count=this.currentAccount.socialProfilesOverage}}
                </li>
              {{/if}}
            </ul>
          {{else}}
            <p>{{t "account.stop_the_world.generic_message"}}</p>
          {{/if}}
        </modal.card-body>
  
        <modal.card-footer>
          <LinkToExternal @route="plans" class="o--btn o--btn--outline" data-test-link-external="plans">
            {{t "account.downgrade.go_to_plans"}}
          </LinkToExternal>
          <LinkTo
            @route={{@routeToDowngrade}}
            class="o--btn o--btn--primary u--float--right"
            data-test-link={{@routeToDowngrade}}
          >
            {{t "shared_words.continue"}}
          </LinkTo>
        </modal.card-footer>
  
      </modal.card>
  
    </Shared::Modal>
  {{/if}}
  */
  {
    "id": "KlDFDvXF",
    "block": "[[[41,[30,0,[\"currentAccount\",\"stopTheWorld\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@closable\"],[false]],[[\"default\"],[[[[1,\"\\n\\n    \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n\\n      \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"account.stop_the_world.title\"],[[\"planName\"],[[30,0,[\"planName\"]]]]]]],null],[1,\"\\n\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"shouldWarnOfPlanOverages\"]],[[[1,\"          \"],[10,2],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.message\"],null]],[13],[1,\"\\n          \"],[10,\"ul\"],[12],[1,\"\\n\"],[41,[30,0,[\"hasLinkinbioPagesOverage\"]],[[[1,\"              \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.linkinbio_pages\"],[[\"count\"],[[30,0,[\"linkinbioPagesOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"currentAccount\",\"hasGroupsOverage\"]],[[[1,\"              \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.groups\"],[[\"count\"],[[30,0,[\"currentAccount\",\"groupsOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasUsersOverage\"]],[[[1,\"              \"],[10,\"li\"],[12],[1,[28,[35,2],[\"account.stop_the_world.overages.users\"],[[\"count\"],[[30,0,[\"currentAccount\",\"usersOverage\"]]]]]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasSocialProfileOverage\"]],[[[1,\"              \"],[10,\"li\"],[12],[1,\"\\n                \"],[1,[28,[35,2],[\"account.stop_the_world.overages.social_profiles\"],[[\"count\"],[[30,0,[\"currentAccount\",\"socialProfilesOverage\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[10,2],[12],[1,[28,[35,2],[\"account.stop_the_world.generic_message\"],null]],[13],[1,\"\\n\"]],[]]],[1,\"      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[39,3],[[24,0,\"o--btn o--btn--outline\"],[24,\"data-test-link-external\",\"plans\"]],[[\"@route\"],[\"plans\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,2],[\"account.downgrade.go_to_plans\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n        \"],[8,[39,4],[[24,0,\"o--btn o--btn--primary u--float--right\"],[16,\"data-test-link\",[30,2]]],[[\"@route\"],[[30,2]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,2],[\"shared_words.continue\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n    \"]],[]]]]],[1,\"\\n\\n  \"]],[1]]]]],[1,\"\\n\"]],[]],null]],[\"modal\",\"@routeToDowngrade\"],false,[\"if\",\"shared/modal\",\"t\",\"link-to-external\",\"link-to\"]]",
    "moduleName": "shared/components/shared/stop-the-world-modal.hbs",
    "isStrictMode": false
  });

  let StopTheWorldModalComponent = (_class = class StopTheWorldModalComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "subscriptions", _descriptor2, this);
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get hasLinkinbioPagesOverage() {
      return this.currentAccount.hasOverageLinkinbioPages;
    }

    get linkinbioPagesOverage() {
      return this.currentAccount.linkinbioPagesOverage;
    }

    get planName() {
      return this.subscriptions.subscriptionPlan?.displayName;
    }

    get showLinkinbioWarning() {
      return this.currentAccount.linkinbioEnabled;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  _exports.default = StopTheWorldModalComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StopTheWorldModalComponent);
});